module.exports = {"private":true,"main":"./oauthApplication.js"}


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/reducers/oauthApplication/package.json
// module id = 852
// module chunks = 0 1